import React, { useState } from "react"
import { useSelector } from "react-redux"
import { updateJobServiceTransition, getJobServicesByJob } from "requesters/jobServiceRequester";
import { Modal, Spinner } from "react-bootstrap"
import SweetAlert from "react-bootstrap-sweetalert"
import { FIELD_WORK_STATES } from "utils/constants"

import { getBaseUrl } from "../../../reducers"
import JobServiceSelectionModal from "./JobServiceSelectionModal"

const JobOnHoldModal = ({
  show, onHide, reloadData, jobService, job
}) => {
  const baseUrl = useSelector(getBaseUrl)

  const [reason, setReason] = useState("")
  const [holdJobButtonClicked, setHoldJobButtonClicked] = useState(false)
  const [onHoldType, setOnHoldType] = useState("client-delayed")
  const [showSelectionModal, setShowSelectionModal] = useState(false)
  const [showHoldConfirmAlert, setShowHoldConfirmAlert] = useState(false)
  const [checkingOtherJobServices, setCheckingOtherJobServices] = useState(false)

  const onSubmitSingle = () => {
    updateJobServiceTransition(baseUrl, jobService?.id, onHoldType, reason)
      .then(() => {
        reloadData()
        onHide()
      })
      // eslint-disable-next-line no-console
      .catch(err => console.log(err))
  }

  const holdTypeLabel =
    onHoldType === "client-delayed" ? "Client Delayed" : "On Hold"

  const handleHoldClick = () => {
    if (!job) {
      onSubmitSingle()
      setHoldJobButtonClicked(true)
      return
    }

    const currentJsId = jobService?.id
    setCheckingOtherJobServices(true)
    getJobServicesByJob(baseUrl, job.id)
      .then((res) => {
        setCheckingOtherJobServices(false)
        if (res.status !== 200) {
          setShowSelectionModal(true)
          return
        }
        const allJobServices = Object.values(
          _.get(res.response, "jobService", {})
        )
        const otherFieldWorkJs = allJobServices.filter(
          (js) =>
            FIELD_WORK_STATES.includes(js.attributes?.state) &&
            String(js.id) !== String(currentJsId)
        )
        if (otherFieldWorkJs.length === 0) {
          setShowHoldConfirmAlert(true)
        } else {
          setShowSelectionModal(true)
        }
      })
      .catch(() => {
        setCheckingOtherJobServices(false)
        setShowSelectionModal(true)
      })
  }

  const handleHoldConfirmAlert = () => {
    updateJobServiceTransition(baseUrl, jobService?.id, onHoldType, reason)
      .then(() => {
        setShowHoldConfirmAlert(false)
        reloadData()
        onHide()
        setHoldJobButtonClicked(false)
      })
      // eslint-disable-next-line no-console
      .catch(err => console.log(err))
  }

  const handleSelectionConfirm = (selectedJobServiceIds) => {
    if (selectedJobServiceIds.length === 0) return;

    const promises = selectedJobServiceIds.map(jsId =>
      updateJobServiceTransition(baseUrl, jsId, onHoldType, reason)
    )

    Promise.all(promises)
      .then(() => {
        setShowSelectionModal(false)
        reloadData()
        onHide()
        setHoldJobButtonClicked(false)
      })
      // eslint-disable-next-line no-console
      .catch(err => console.log(err))
  }

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title><h2 className="modal-title">Job On Hold</h2></Modal.Title>
      </Modal.Header>
      <div className="modal-body">
        <form>
          <div className="col-12 mb-2">
            <label className="mr-4 cursor-pointer">
              <input
                className="mr-1 cursor-pointer"
                name="radio-client-delayed"
                type="radio"
                value="client-delayed"
                checked={onHoldType === "client-delayed"}
                onChange={() => { setOnHoldType("client-delayed") }} />
              Client Delayed
            </label>
            <label className="mr-4 cursor-pointer">
              <input
                className="mr-1 cursor-pointer"
                name="radio-on-hold"
                type="radio"
                value="on-hold"
                checked={onHoldType === "on-hold"}
                onChange={() => { setOnHoldType("on-hold") }} />
              On Hold
            </label>
          </div>
          <div className="col-12 mb-5">
            <textarea
              name="flag_notes"
              className="form-control"
              placeholder="Notes*"
              rows="4"
              value={reason}
              onChange={e => setReason(e.target.value)}>
            </textarea>
          </div>
        </form>
        <div className="modal-footer d-flex justify-content-end p-0 mb-4 mt-5">
          <button
            className="btn btn-link btn-lg"
            onClick={onHide}
            type="submit">
            Close
          </button>
          <button
            className="btn btn-red btn-lg"
            onClick={handleHoldClick}
            disabled={!reason || holdJobButtonClicked || checkingOtherJobServices}
            type="submit">
            Hold Job
            {checkingOtherJobServices && (
              <Spinner className="ml-1" animation="border" role="status" size="sm" />
            )}
          </button>
        </div>
      </div>

      <SweetAlert
        show={showHoldConfirmAlert}
        type="warning"
        title="Are you sure?"
        closeOnClickOutside
        allowEscape={false}
        showCloseButton
        onCancel={() => setShowHoldConfirmAlert(false)}
        confirmBtnText="Proceed"
        onConfirm={handleHoldConfirmAlert}>
        <p className="mb-2">
          Put this job service <strong>{holdTypeLabel}</strong>?
        </p>
        <p className="mb-0 text-muted small">Notes:</p>
        <strong>{reason}</strong>
      </SweetAlert>

      <JobServiceSelectionModal
        show={showSelectionModal}
        onHide={() => setShowSelectionModal(false)}
        job={job}
        jobService={jobService}
        actionType={onHoldType}
        onConfirm={handleSelectionConfirm} />
    </Modal>
  )
}
export default JobOnHoldModal
